import { createContext } from 'react';
import type { DisplayPrefs } from '@aiax-hub/contracts';

export const DisplayPreferencesContext = createContext<Pick<DisplayPrefs, 'numberUnit' | 'wrapLongText'>>({ numberUnit: 'compact', wrapLongText: true });
